import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/primeng';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { QFilterModel } from '../../../models/qfilter.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from "../../../models/search-toolbar-factory-parameters.model";
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { OverviewLoyaltyPointsComponent } from './overview-loyalty-points/overview-loyalty-points.component';
import { OverviewLoyaltyValueComponent } from './overview-loyalty-value/overview-loyalty-value.component';


@Component({
  selector: 'app-loyalty-overview',
  templateUrl: './loyalty-overview.component.html',
  styleUrls: ['./loyalty-overview.component.css']
})
export class LoyaltyOverviewComponent implements OnInit {
  @ViewChild(OverviewLoyaltyValueComponent) loyaltyValue: OverviewLoyaltyValueComponent;
  @ViewChild(OverviewLoyaltyPointsComponent) loyaltyPoints: OverviewLoyaltyPointsComponent;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  items: MenuItem[];
  activeIndex: number;
  oldData: any;
  translations: any;

  selectedElapsedStart: Date = null;
  selectedElapsedEnd: Date = null;

  constructor (
    private tService: TranslateService,
    private svcAnalytics: AnalyticsService,
    private searchModelFactory: SearchToolbarModelFactoryService
  ) { }

  ngOnInit() {
    this.tService.get([
      'loyalty_chart.value',
      'loyalty_chart.points',
    ]).subscribe((t) => {

      const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
      searchParams.svcAnalytics = this.svcAnalytics;
      searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
      searchParams.finestra = SearchToolbarFilterWindow.Six;
      searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
      searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist];

      this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
        this.searchModel = model;
      });


      this.translations = {
        value: t['loyalty_chart.value'],
        points: t['loyalty_chart.points'],
      };

      this.activeIndex = 0;
      this.items = [];

      this.items.push(
        {
          label: this.translations.value,
          command: (event: any) => {
            this.activeIndex = 0;
          }
        },
        {
          label: this.translations.points,
          command: (event: any) => {
            this.activeIndex = 1;
          }
        }
      );
    });
  }

  dateStructureSelectionChange($event) {
    console.log('somethings', $event);
  }

  performFilter(data: QFilterModel) {

    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    if (this.activeIndex === 0) {
      if (!isDataEquals) {
        this.loyaltyPoints.resetData();
      }

      this.loyaltyValue.searchValueTrend(data);
    } else if (this.activeIndex === 1) {
      if (!isDataEquals) {
        this.loyaltyValue.resetData();
      }

      this.loyaltyPoints.searchValueTrend(data);
    }

    this.oldData = { ...data };
  }
}



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/loyalty-overview.component.ts